import {
  toSet2orjxp16sotqu as toSet,
  plus310ted5e4i90h as plus,
  contains2gm06f5aa19ov as contains,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toLineItems19fpah7suhbci as toLineItems } from '../../../../../crowpay-shared/com/crowpay/extensions/Specification.ext.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import {
  addAll1k27qatfgp3k5 as addAll,
  removeAll1oodkx28jk9ud as removeAll,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  toString30pk9tzaqopn as toString,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { RemoveOutline_getInstance2r2ekg5cxorga as RemoveOutline_getInstance } from '../theming/appTheme.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  get_italic11nskfy97pz2f as get_italic,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
  timesx4ey3un7ihw1 as times,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  align1ejncrrer3meh as align,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { leftExpandButton23soimuuf6gel as leftExpandButton } from '../components/expansion.mjs';
import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
  Indent_HalfSection_getInstance3e9u4kbpkw4rx as Indent_HalfSection_getInstance,
} from '../components/space.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_padded3m3frjnjujncx as get_padded,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  body3i5t0n7zprpqb as body,
  smallBody2trfy14zwtona as smallBody,
  title1nssp3ryhwuqj as title,
  bodyBold2czwdzwknab0k as bodyBold,
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
} from '../theming/Titles.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../theming/separators.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  truncate3gvhc1a2is66m as truncate,
  filterNullKeys1r8wmaox0efdd as filterNullKeys,
} from '../../utils/utils.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { Specification3fgfbf7ihgj8v as Specification } from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_contractorko2ied3oyiyr as get_contractor } from '../../../../../crowpay-shared/com/crowpay/SpecificationFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { debounce3uffs71hj1o26 as debounce } from '../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  contains3ue2qo8xhmpf1 as contains_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../theming/sections.mjs';
import { scopeSetIcon1d64me82i5zfn as scopeSetIcon } from '../components/iconShortcuts.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText33v0vmsdeuehr as specCenteredText_0,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var selected = toSet($this.gig_1.big_1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.gig_1.aig_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (selected.t1(element.s83_1)) {
      destination.v(element);
    }
  }
  var tmp_0 = $this.gig_1.yif_1(toLineItems(destination, $this.gig_1.xif_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  get_dialogStack().pgd();
  return Unit_instance;
}
var SpecGroupClass;
function SpecGroup() {
  if (SpecGroupClass === VOID) {
    class $ {
      constructor(group, topLevelItems, subgroups) {
        this.hig_1 = group;
        this.iig_1 = topLevelItems;
        this.jig_1 = subgroups;
        var tmp = this;
        // Inline function 'kotlin.collections.flatMap' call
        var tmp0 = this.jig_1;
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination = ArrayList().w();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = tmp0.d2().m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var list = element.f2();
          addAll(destination, list);
        }
        tmp.kig_1 = plus(this.iig_1, destination);
      }
      toString() {
        return 'SpecGroup(group=' + toString(this.hig_1) + ', topLevelItems=' + toString_0(this.iig_1) + ', subgroups=' + toString_0(this.jig_1) + ')';
      }
      hashCode() {
        var result = this.hig_1 == null ? 0 : this.hig_1.hashCode();
        result = imul(result, 31) + hashCode(this.iig_1) | 0;
        result = imul(result, 31) + hashCode(this.jig_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpecGroup()))
          return false;
        if (!equals(this.hig_1, other.hig_1))
          return false;
        if (!equals(this.iig_1, other.iig_1))
          return false;
        if (!equals(this.jig_1, other.jig_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SpecGroup');
    SpecGroupClass = $;
  }
  return SpecGroupClass;
}
function allSelected($this, items) {
  var tmp = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this.big_1).l3(items));
  return withWrite(tmp, NewTasksFromSpecsDialog$allSelected$slambda_0($this, items));
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.lig_1 = function_0;
      }
      wi(a, b) {
        return this.lig_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.lig_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems_w2128e(_this__u8e3s4, $data, this$0, items) {
  if (items.i1())
    return Unit_instance;
  var tmp = _this__u8e3s4.jbb(ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var spec = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(true);
    view_0.bb9(get_rem(0));
    var expanded = Signal().hak(false);
    var tmp_0 = view_0.kbb(view_0.jbb(RemoveOutline_getInstance()), get_compact(view_0));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    view_1.zbm(false);
    var tmp0_safe_receiver = $data.hig_1;
    if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p82_1) === true)) {
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Frame())(view_1.pc());
      var tmp0_elvis_lhs_2 = view_1.ebb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
      view_1.gbb(p_2, view_2);
      var tmp_1 = align(view_2, Align_Start_getInstance(), Align_Center_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (Checkbox())(view_2.pc());
      var tmp0_elvis_lhs_3 = view_2.ebb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
      view_2.gbb(p_3, view_3);
      view_3.zah(view_3.ebk_1, this$0.big_1.can(spec.s83_1));
      view_2.hbb(p_3, view_3);
      view_2.lbb(tmp_1, view_3);
      view_1.hbb(p_2, view_2);
    }
    var tmp_2 = get_expanding(view_1);
    view_1.lbb(tmp_2, leftExpandButton(view_1, expanded, VOID, VOID, VOID, VOID, NewTasksFromSpecsDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda_22wlrx(spec)));
    view_0.hbb(p_1, view_1);
    view_0.lbb(tmp_0, view_1);
    // Inline function 'com.crowpay.views.components.sectionIndentCol' call
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var indent = Indent_Section_getInstance();
    var tmp2 = indent.agr_1;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var afterSpace = indent.bgr_1;
    var tmp_3 = get_unpadded(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (Frame())(view_0.pc());
    var tmp0_elvis_lhs_4 = view_0.ebb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
    view_0.gbb(p_4, view_4);
    var tmp_4;
    var tmp_5 = null;
    if (!((tmp_5 == null ? null : new (Dimension())(tmp_5)) == null)) {
      tmp_4 = sizeConstraints(view_4, VOID, VOID, VOID, VOID, VOID, null);
    } else {
      tmp_4 = Companion_getInstance();
    }
    var tmp_6 = view_4.kbb(tmp_4, indented(view_4, tmp2, afterSpace));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.ebb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.gbb(p_5, view_5);
    view_5.zbm(true);
    var tmp_7 = get_padded(view_5);
    view_5.lbb(view_5.kbb(tmp_7, shownWhen(view_5, VOID, NewTasksFromSpecsDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda_22wlrx_0(expanded))), body(view_5, spec.w83_1));
    greySeparator(view_5);
    view_4.hbb(p_5, view_5);
    view_4.lbb(tmp_6, view_5);
    view_0.hbb(p_4, view_4);
    view_0.lbb(tmp_3, view_4);
    view.hbb(p_0, view_0);
  }
  _this__u8e3s4.hbb(p, view);
  _this__u8e3s4.lbb(tmp, view);
}
function NewTasksFromSpecsDialog$filteredSpecGroups$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_safe_receiver = a.hig_1;
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n82_1;
  var tmp0_safe_receiver_0 = b.hig_1;
  var tmp$ret$1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.n82_1;
  return compareValues(tmp, tmp$ret$1);
}
var NewTasksFromSpecsDialog$allSelected$slambdaClass;
function NewTasksFromSpecsDialog$allSelected$slambda() {
  if (NewTasksFromSpecsDialog$allSelected$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $items) {
        this.mig_1 = this$0;
        this.nig_1 = $items;
      }
      cfz($this$withWrite, selected, $completion) {
        if (selected) {
          var tmp0 = this.mig_1.big_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var elements = this.nig_1;
          addAll(tmp0, elements);
        } else {
          var tmp0_0 = this.mig_1.big_1;
          // Inline function 'kotlin.collections.minusAssign' call
          var elements_0 = this.nig_1;
          removeAll(tmp0_0, elements_0);
        }
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.cfz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    NewTasksFromSpecsDialog$allSelected$slambdaClass = $;
  }
  return NewTasksFromSpecsDialog$allSelected$slambdaClass;
}
function NewTasksFromSpecsDialog$allSelected$slambda_0(this$0, $items) {
  var i = new (NewTasksFromSpecsDialog$allSelected$slambda())(this$0, $items);
  var l = ($this$withWrite, selected, $completion) => i.cfz($this$withWrite, selected, $completion);
  l.$arity = 2;
  return l;
}
var NewTasksFromSpecsDialog$render$slambdaClass;
function NewTasksFromSpecsDialog$render$slambda() {
  if (NewTasksFromSpecsDialog$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    NewTasksFromSpecsDialog$render$slambdaClass = $;
  }
  return NewTasksFromSpecsDialog$render$slambdaClass;
}
function NewTasksFromSpecsDialog$render$slambda_0() {
  var i = new (NewTasksFromSpecsDialog$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var NewTasksFromSpecsDialog$render$slambdaClass_0;
function NewTasksFromSpecsDialog$render$slambda_1() {
  if (NewTasksFromSpecsDialog$render$slambdaClass_0 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    NewTasksFromSpecsDialog$render$slambdaClass_0 = $;
  }
  return NewTasksFromSpecsDialog$render$slambdaClass_0;
}
function NewTasksFromSpecsDialog$render$slambda_2() {
  var i = new (NewTasksFromSpecsDialog$render$slambda_1())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var NewTasksFromSpecsDialog$render$slambdaClass_1;
function NewTasksFromSpecsDialog$render$slambda_3() {
  if (NewTasksFromSpecsDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.gig_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    NewTasksFromSpecsDialog$render$slambdaClass_1 = $;
  }
  return NewTasksFromSpecsDialog$render$slambdaClass_1;
}
function NewTasksFromSpecsDialog$render$slambda_4(this$0) {
  var i = new (NewTasksFromSpecsDialog$render$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function NewTasksFromSpecsDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda_22wlrx($spec) {
  return ($this$leftExpandButton) => {
    body($this$leftExpandButton, $spec.v83_1);
    $this$leftExpandButton.lbb($this$leftExpandButton.kbb($this$leftExpandButton.kbb(get_expanding($this$leftExpandButton), get_centered($this$leftExpandButton)), get_italic($this$leftExpandButton)), smallBody($this$leftExpandButton, truncate($spec.w83_1, 50)));
    var tmp;
    var tmp_0 = $spec.x83_1;
    // Inline function 'kotlin.let' call
    var tmp_1 = tmp_0 == null ? null : new (MonetaryValue())(tmp_0);
    var it = tmp_1 == null ? null : tmp_1.y5r_1;
    var tmp_2;
    var tmp_3 = it;
    if (!((tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) == null)) {
      tmp_2 = MonetaryValue__compareTo_impl_w7ul1r(it, Companion_instance.r91(0n)) > 0;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      var tmp_4 = get_centered($this$leftExpandButton);
      var tmp0_elvis_lhs = $spec.x83_1;
      var tmp_5;
      var tmp_6 = tmp0_elvis_lhs;
      if ((tmp_6 == null ? null : new (MonetaryValue())(tmp_6)) == null) {
        tmp_5 = Companion_instance.m62(0);
      } else {
        tmp_5 = tmp0_elvis_lhs;
      }
      $this$leftExpandButton.lbb(tmp_4, smallBody($this$leftExpandButton, MonetaryValue__toString_impl_xslc77(tmp_5)));
      var tmp_7;
      if (!($spec.y83_1 == null)) {
        $this$leftExpandButton.lbb(get_centered($this$leftExpandButton), smallBody($this$leftExpandButton, '/'));
        var tmp_8 = get_centered($this$leftExpandButton);
        var tmp1_elvis_lhs = $spec.y83_1;
        $this$leftExpandButton.lbb(tmp_8, smallBody($this$leftExpandButton, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs));
        tmp_7 = Unit_instance;
      }
      tmp = tmp_7;
    }
    return Unit_instance;
  };
}
function NewTasksFromSpecsDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda_22wlrx_0($expanded) {
  return ($this$shownWhen) => $this$shownWhen.daj($expanded);
}
var NewTasksFromSpecsDialogClass;
function NewTasksFromSpecsDialog() {
  if (NewTasksFromSpecsDialogClass === VOID) {
    class $ {
      constructor(contractorId, projectId, withTasks) {
        this.wif_1 = contractorId;
        this.xif_1 = projectId;
        this.yif_1 = withTasks;
        var tmp = this;
        tmp.zif_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).qfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Specification()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp$ret$4 = eq(get_contractor(it), this.wif_1);
          return tmp.heo(new (Query())(tmp$ret$4, VOID, VOID, 2147483647));
        });
        var tmp_0 = this;
        tmp_0.aig_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.zif_1)));
        this.big_1 = ReactiveMutableList().vam();
        this.cig_1 = Signal().hak('');
        this.dig_1 = debounce(this.cig_1, 200n);
        var tmp_1 = this;
        tmp_1.eig_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var specs = $this$remember.daj(this.aig_1);
          // Inline function 'kotlin.takeUnless' call
          var this_0 = $this$remember.daj(this.dig_1);
          var tmp;
          if (!isBlank(this_0)) {
            tmp = this_0;
          } else {
            tmp = null;
          }
          var tmp0_safe_receiver = tmp;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s = specs.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_1;
              var tmp_2;
              var tmp0_safe_receiver_0 = element.u83_1;
              var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.n82_1;
              if ((tmp1_safe_receiver == null ? null : contains_0(tmp1_safe_receiver, tmp0_safe_receiver, true)) === true) {
                tmp_2 = true;
              } else {
                tmp_2 = contains_0(element.v83_1, tmp0_safe_receiver, true);
              }
              if (tmp_2) {
                tmp_1 = true;
              } else {
                tmp_1 = contains_0(element.w83_1, tmp0_safe_receiver, true);
              }
              if (tmp_1) {
                destination.v(element);
              }
            }
            var queried = destination;
            // Inline function 'kotlin.collections.mapNotNull' call
            // Inline function 'kotlin.collections.mapNotNullTo' call
            var destination_0 = ArrayList().w();
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s_0 = queried.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              var tmp0_safe_receiver_1 = element_0.u83_1;
              var tmp0_safe_receiver_2 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.n82_1;
              if (tmp0_safe_receiver_2 == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                destination_0.v(tmp0_safe_receiver_2);
              }
            }
            var groups = toSet(destination_0);
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_1 = ArrayList().u(collectionSizeOrDefault(queried, 10));
            var _iterator__ex2g4s_1 = queried.m1();
            while (_iterator__ex2g4s_1.n1()) {
              var item = _iterator__ex2g4s_1.o1();
              var tmp$ret$17 = item.s83_1;
              destination_1.v(tmp$ret$17);
            }
            var ids = toSet(destination_1);
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination_2 = ArrayList().w();
            var _iterator__ex2g4s_2 = specs.m1();
            while (_iterator__ex2g4s_2.n1()) {
              var element_1 = _iterator__ex2g4s_2.o1();
              var tmp_3;
              if (ids.t1(element_1.s83_1)) {
                tmp_3 = true;
              } else {
                var tmp0_safe_receiver_3 = element_1.u83_1;
                tmp_3 = contains(groups, tmp0_safe_receiver_3 == null ? null : tmp0_safe_receiver_3.n82_1);
              }
              if (tmp_3) {
                destination_2.v(element_1);
              }
            }
            tmp_0 = destination_2;
          }
          var tmp1_elvis_lhs = tmp_0;
          return tmp1_elvis_lhs == null ? specs : tmp1_elvis_lhs;
        });
        var tmp_2 = this;
        tmp_2.fig_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.daj(this.eig_1);
          // Inline function 'kotlin.collections.groupByTo' call
          var destination = LinkedHashMap().f6();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var key = element.u83_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element);
          }
          var specs = destination;
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = LinkedHashMap().f6();
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = specs.d2().m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp0_safe_receiver = element_0.e2();
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q82_1) == null) {
              destination_0.s3(element_0.e2(), element_0.f2());
            }
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_1 = ArrayList().u(destination_0.p1());
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_1 = destination_0.d2().m1();
          while (_iterator__ex2g4s_1.n1()) {
            var item = _iterator__ex2g4s_1.o1();
            // Inline function 'kotlin.collections.component1' call
            var group = item.e2();
            // Inline function 'kotlin.collections.component2' call
            var items = item.f2();
            var tmp_0;
            if (group == null) {
              tmp_0 = emptyMap();
            } else {
              // Inline function 'kotlin.collections.filter' call
              // Inline function 'kotlin.collections.filterTo' call
              var destination_2 = LinkedHashMap().f6();
              // Inline function 'kotlin.collections.iterator' call
              var _iterator__ex2g4s_2 = specs.d2().m1();
              while (_iterator__ex2g4s_2.n1()) {
                var element_1 = _iterator__ex2g4s_2.o1();
                var tmp0_safe_receiver_0 = element_1.e2();
                if (equals(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.q82_1, group.m82_1)) {
                  destination_2.s3(element_1.e2(), element_1.f2());
                }
              }
              tmp_0 = filterNullKeys(destination_2);
            }
            var tmp$ret$41 = new (SpecGroup())(group, items, tmp_0);
            destination_1.v(tmp$ret$41);
          }
          // Inline function 'kotlin.collections.sortedBy' call
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp_1 = NewTasksFromSpecsDialog$filteredSpecGroups$lambda$lambda;
          var tmp$ret$44 = new (sam$kotlin_Comparator$0())(tmp_1);
          return sortedWith(destination_1, tmp$ret$44);
        });
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(NewTasksFromSpecsDialog$render$slambda_0());
        view.gba(get_AppDimensions().zg1_1);
        var tmp = view.kbb(view.kbb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(45), get_rem(60)), get_centered(view)), view.jbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.gba(get_AppDimensions().yg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        title(view_1, 'New Tasks From Specifications');
        // Inline function 'com.crowpay.views.components.field2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(true);
        view_2.bb9(get_AppDimensions().pg2_1);
        bodyBold(view_2, 'Search');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_0 = view_2.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextInput())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value = 'Specification Group, Title, Description';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_3.vb5_1.bb4_1.kb7_1.placeholder = value;
        view_3.zah(view_3.icn_1, this.cig_1);
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_0, view_3);
        view_2.lbb(view_2.jbb(SubtextSemantic_getInstance()), errorText(view_2));
        view_1.hbb(p_2, view_2);
        boldSubTitle(view_1, 'Available Specifications');
        var tmp_1 = view_1.kbb(get_expanding(view_1), get_scrolling(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_4 = view_1.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
        view_1.gbb(p_4, view_4);
        view_4.zbm(true);
        view_4.bb9(times(view_4.mba().jb0_1, 1.5));
        forEach(view_4, this.fig_1, ($this$forEach, data) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = data.kig_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$12 = item.s83_1;
            destination.v(tmp$ret$12);
          }
          var groupSelected = allSelected(this, toSet(destination));
          var tmp = $this$forEach.kbb(get_lightSection($this$forEach), get_compact($this$forEach));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$forEach.pc());
          var tmp0_elvis_lhs = $this$forEach.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
          $this$forEach.gbb(p, view);
          view.zbm(false);
          if (!(data.hig_1 == null)) {
            // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (Frame())(view.pc());
            var tmp0_elvis_lhs_0 = view.ebb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
            view.gbb(p_0, view_0);
            var tmp_0 = align(view_0, Align_Start_getInstance(), Align_Center_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_1 = new (Checkbox())(view_0.pc());
            var tmp0_elvis_lhs_1 = view_0.ebb_1;
            var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
            view_0.gbb(p_1, view_1);
            view_1.zah(view_1.ebk_1, groupSelected);
            view_0.hbb(p_1, view_1);
            view_0.lbb(tmp_0, view_1);
            view.hbb(p_0, view_0);
          }
          var tmp_1 = view.kbb(get_expanding(view), get_compact(view));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_2 = view.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
          view.gbb(p_2, view_2);
          view_2.zbm(false);
          var tmp0_safe_receiver = data.hig_1;
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p82_1) === true) {
            view_2.lbb(get_centered(view_2), scopeSetIcon(view_2, get_rem_0(1.3)));
          }
          var tmp_2 = get_centered(view_2);
          // Inline function 'com.crowpay.views.theming.bodyBold' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (TextView())(view_2.pc());
          var tmp0_elvis_lhs_3 = view_2.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.gbb(p_3, view_3);
          view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
          var tmp0_safe_receiver_0 = data.hig_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.n82_1;
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = tmp1_elvis_lhs == null ? 'Individual Specifications' : tmp1_elvis_lhs;
          var tmp_3 = view_3.vb5_1;
          var tmp_4;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_4 = '\xA0';
          } else {
            tmp_4 = value;
          }
          tmp_3.hbu(tmp_4);
          view_2.hbb(p_3, view_3);
          view_2.lbb(tmp_2, view_3);
          var tmp_5 = view_2.kbb(view_2.kbb(get_expanding(view_2), get_centered(view_2)), get_italic(view_2));
          var tmp1_safe_receiver = data.hig_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.o82_1;
          view_2.lbb(tmp_5, smallBody(view_2, tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs));
          var tmp_6 = get_centered(view_2);
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (TextView())(view_2.pc());
          var tmp0_elvis_lhs_4 = view_2.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
          view_2.gbb(p_4, view_4);
          view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
          view_4.dbs(Align_End_getInstance());
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var this_1 = data.kig_1;
          var sum = Companion_instance.r91(0n);
          var _iterator__ex2g4s_0 = this_1.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element = _iterator__ex2g4s_0.o1();
            var tmp_7 = sum;
            var tmp0_elvis_lhs_5 = element.x83_1;
            var tmp_8;
            var tmp_9 = tmp0_elvis_lhs_5;
            if ((tmp_9 == null ? null : new (MonetaryValue())(tmp_9)) == null) {
              tmp_8 = Companion_instance.m62(0);
            } else {
              tmp_8 = tmp0_elvis_lhs_5;
            }
            var tmp$ret$28 = tmp_8;
            sum = MonetaryValue__plus_impl_c1ylt(tmp_7, tmp$ret$28);
          }
          var price = sum;
          view_4.zb8(MonetaryValue__compareTo_impl_w7ul1r(price, Companion_instance.r91(0n)) > 0);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value_0 = MonetaryValue__toString_impl_xslc77(price);
          var tmp_10 = view_4.vb5_1;
          var tmp_11;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value_0) === 0) {
            tmp_11 = '\xA0';
          } else {
            tmp_11 = value_0;
          }
          tmp_10.hbu(tmp_11);
          view_2.hbb(p_4, view_4);
          view_2.lbb(tmp_6, view_4);
          view.hbb(p_2, view_2);
          view.lbb(tmp_1, view_2);
          $this$forEach.hbb(p, view);
          $this$forEach.lbb(tmp, view);
          // Inline function 'com.crowpay.views.components.indentedCol' call
          var indent = Indent_HalfSection_getInstance();
          var tmp2 = indent.agr_1;
          // Inline function 'com.crowpay.views.components.indentedCol' call
          var afterSpace = indent.bgr_1;
          var tmp_12 = get_unpadded($this$forEach);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (Frame())($this$forEach.pc());
          var tmp0_elvis_lhs_6 = $this$forEach.ebb_1;
          var p_5 = tmp0_elvis_lhs_6 == null ? $this$forEach : tmp0_elvis_lhs_6;
          $this$forEach.gbb(p_5, view_5);
          var tmp_13;
          var tmp_14 = null;
          if (!((tmp_14 == null ? null : new (Dimension())(tmp_14)) == null)) {
            tmp_13 = sizeConstraints(view_5, VOID, VOID, VOID, VOID, VOID, null);
          } else {
            tmp_13 = Companion_getInstance();
          }
          var tmp_15 = view_5.kbb(tmp_13, indented(view_5, tmp2, afterSpace));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (RowOrCol())(view_5.pc());
          var tmp0_elvis_lhs_7 = view_5.ebb_1;
          var p_6 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
          view_5.gbb(p_6, view_6);
          view_6.zbm(true);
          render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems_w2128e(view_6, data, this, data.iig_1);
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_1 = data.jig_1.d2().m1();
          while (_iterator__ex2g4s_1.n1()) {
            var _destruct__k2r9zo = _iterator__ex2g4s_1.o1();
            // Inline function 'kotlin.collections.component1' call
            var sub = _destruct__k2r9zo.e2();
            // Inline function 'kotlin.collections.component2' call
            var items = _destruct__k2r9zo.f2();
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_7 = new (RowOrCol())(view_6.pc());
            var tmp0_elvis_lhs_8 = view_6.ebb_1;
            var p_7 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
            view_6.gbb(p_7, view_7);
            view_7.zbm(true);
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList().u(collectionSizeOrDefault(items, 10));
            var _iterator__ex2g4s_2 = items.m1();
            while (_iterator__ex2g4s_2.n1()) {
              var item_0 = _iterator__ex2g4s_2.o1();
              var tmp$ret$48 = item_0.s83_1;
              destination_0.v(tmp$ret$48);
            }
            var subSelected = allSelected(this, toSet(destination_0));
            var tmp_16 = view_7.kbb(get_lightSection(view_7), get_compact(view_7));
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_8 = new (RowOrCol())(view_7.pc());
            var tmp0_elvis_lhs_9 = view_7.ebb_1;
            var p_8 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
            view_7.gbb(p_8, view_8);
            view_8.zbm(false);
            var tmp0_safe_receiver_1 = data.hig_1;
            if (!((tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.p82_1) === true)) {
              // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_9 = new (Frame())(view_8.pc());
              var tmp0_elvis_lhs_10 = view_8.ebb_1;
              var p_9 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
              view_8.gbb(p_9, view_9);
              var tmp_17 = align(view_9, Align_Start_getInstance(), Align_Center_getInstance());
              // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_10 = new (Checkbox())(view_9.pc());
              var tmp0_elvis_lhs_11 = view_9.ebb_1;
              var p_10 = tmp0_elvis_lhs_11 == null ? view_9 : tmp0_elvis_lhs_11;
              view_9.gbb(p_10, view_10);
              view_10.zah(view_10.ebk_1, subSelected);
              view_9.hbb(p_10, view_10);
              view_9.lbb(tmp_17, view_10);
              view_8.hbb(p_9, view_9);
            }
            var tmp_18 = view_8.kbb(get_expanding(view_8), get_compact(view_8));
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_11 = new (RowOrCol())(view_8.pc());
            var tmp0_elvis_lhs_12 = view_8.ebb_1;
            var p_11 = tmp0_elvis_lhs_12 == null ? view_8 : tmp0_elvis_lhs_12;
            view_8.gbb(p_11, view_11);
            view_11.zbm(false);
            view_11.lbb(get_centered(view_11), bodyBold(view_11, sub.n82_1));
            var tmp_19 = view_11.kbb(view_11.kbb(get_expanding(view_11), get_centered(view_11)), get_italic(view_11));
            var tmp0_elvis_lhs_13 = sub.o82_1;
            view_11.lbb(tmp_19, smallBody(view_11, tmp0_elvis_lhs_13 == null ? '' : tmp0_elvis_lhs_13));
            var tmp_20 = get_centered(view_11);
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_12 = new (TextView())(view_11.pc());
            var tmp0_elvis_lhs_14 = view_11.ebb_1;
            var p_12 = tmp0_elvis_lhs_14 == null ? view_11 : tmp0_elvis_lhs_14;
            view_11.gbb(p_12, view_12);
            view_12.lba(view_12.qb6_1.abf(BodySemantic_getInstance()));
            view_12.dbs(Align_End_getInstance());
            // Inline function 'com.crowpay.extensions.sumMoney' call
            var sum_0 = Companion_instance.r91(0n);
            var _iterator__ex2g4s_3 = items.m1();
            while (_iterator__ex2g4s_3.n1()) {
              var element_0 = _iterator__ex2g4s_3.o1();
              var tmp_21 = sum_0;
              var tmp0_elvis_lhs_15 = element_0.x83_1;
              var tmp_22;
              var tmp_23 = tmp0_elvis_lhs_15;
              if ((tmp_23 == null ? null : new (MonetaryValue())(tmp_23)) == null) {
                tmp_22 = Companion_instance.m62(0);
              } else {
                tmp_22 = tmp0_elvis_lhs_15;
              }
              var tmp$ret$57 = tmp_22;
              sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_21, tmp$ret$57);
            }
            var price_0 = sum_0;
            view_12.zb8(MonetaryValue__compareTo_impl_w7ul1r(price_0, Companion_instance.r91(0n)) > 0);
            // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
            var value_1 = MonetaryValue__toString_impl_xslc77(price_0);
            var tmp_24 = view_12.vb5_1;
            var tmp_25;
            // Inline function 'kotlin.text.isEmpty' call
            if (charSequenceLength(value_1) === 0) {
              tmp_25 = '\xA0';
            } else {
              tmp_25 = value_1;
            }
            tmp_24.hbu(tmp_25);
            view_11.hbb(p_12, view_12);
            view_11.lbb(tmp_20, view_12);
            view_8.hbb(p_11, view_11);
            view_8.lbb(tmp_18, view_11);
            view_7.hbb(p_8, view_8);
            view_7.lbb(tmp_16, view_8);
            render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems_w2128e(view_7, data, this, items);
            view_6.hbb(p_7, view_7);
          }
          view_5.hbb(p_6, view_6);
          view_5.lbb(tmp_15, view_6);
          $this$forEach.hbb(p_5, view_5);
          $this$forEach.lbb(tmp_12, view_5);
          return Unit_instance;
        });
        view_1.hbb(p_4, view_4);
        view_1.lbb(tmp_1, view_4);
        view_1.lbb(view_1.kbb(shownWhen(view_1, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.eig_1).i1()), get_expanding(view_1)), body(view_1, 'No Specifications match the current search query'));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Space())(view_1.pc());
        var tmp0_elvis_lhs_5 = view_1.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
        view_1.gbb(p_5, view_5);
        view_1.hbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_6 = view_1.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_1 : tmp0_elvis_lhs_6;
        view_1.gbb(p_6, view_6);
        view_6.zbm(false);
        var tmp_2 = get_secondaryButton(view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Button())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.gbb(p_7, view_7);
        specCenteredText(view_7, 'Discard');
        onClick(view_7, 'Discard Scope View', VOID, NewTasksFromSpecsDialog$render$slambda_2());
        view_6.hbb(p_7, view_7);
        view_6.lbb(tmp_2, view_7);
        var tmp_3 = get_primaryButton(view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_6.pc());
        var tmp0_elvis_lhs_8 = view_6.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
        view_6.gbb(p_8, view_8);
        var tmp_4 = KMutableProperty0();
        var tmp_5 = Button$_get_enabled_$ref_61t7nx(view_8);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Button$_set_enabled_$ref_o8kynz(view_8));
        reactiveScope(view_8, ($this$reactiveScope) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          var tmp$ret$98 = !$this$reactiveScope.daj(this.big_1).i1();
          this_0.set(tmp$ret$98);
          return Unit_instance;
        });
        specCenteredText_0(view_8, ($this$specCenteredText) => 'Create ' + $this$specCenteredText.daj(this.big_1).p1() + ' New Items');
        onClick(view_8, 'Create New Items', VOID, NewTasksFromSpecsDialog$render$slambda_4(this));
        view_6.hbb(p_8, view_8);
        view_6.lbb(tmp_3, view_8);
        view_1.hbb(p_6, view_6);
        view_0.hbb(p_1, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'NewTasksFromSpecsDialog', VOID, VOID, [Page()]);
    NewTasksFromSpecsDialogClass = $;
  }
  return NewTasksFromSpecsDialogClass;
}
//region block: exports
export {
  NewTasksFromSpecsDialog as NewTasksFromSpecsDialogooupp0z882ky,
};
//endregion

//# sourceMappingURL=NewTasksFromSpecsDialog.mjs.map
